
import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";

const Main = ({ DrawerHeader }) => {
    return (
        <Box component="main" id="main" className='w-full h-full'>
            <DrawerHeader />
            <div className="p-8 w-full h-full" >
                <Outlet />
            </div>
        </Box>
    )
}

export default Main